import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Sneg",
  "description": "",
  "published": "2007-03-19T00:00:00.000Z",
  "redirect_from": ["/blog/sneg/swizec/258"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Pomlad je ze kajne? Se vceraj je bilo skoraj 20°C ce me spomin ne vara? No ocitno se je nekaj odlocilo in nam podalo koscek zimskega vzdusja ... saj je samo stiri mesece prepozno.`}</p>
    <p>{`Kot kaze tisto globalno ogrevanje, o katerem vsi civkajo, kaze svoje grde roge in se poigrava z nasimi letnimi casi. Ze lani so se dogajale nadvse cudne stvari z neznansko mocnim snezenjem po celi Evropi in nasploh zanimivo zimo. Sedaj pa ze celo zimo zime sploh ni bilo in kakor slisim je bilo temu tako takorekoc po celi Evropi. No sedaj je tukaj, zima namrec.`}</p>
    <p>{`Tezko si je predstavljati, ampak globvalno segrevanje naj ne bi povzrocalo toplejsega vremena, marvec kaoticnejsega ... ce je znanstvenikom za verjeti seveda. Prav rad sem odrascal z idejo nekako stalnih letnih casov in upam, da se glede tega stvari ne bodo drasticno spremenile.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      